import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { LanguageProvider } from 'containers/LanguageProvider';
import configureStore from 'store/config/configureStore';
import { translationMessages } from 'i18n';
import Root from 'containers/Root';

// Create redux store with history
const initialState = {};
const store = configureStore(initialState);

function App() {
  return (
    <Provider store={store}>
      <LanguageProvider messages={translationMessages} locale="en">
        <BrowserRouter future={{ v7_relativeSplatPath: true }}>
          <Root />
        </BrowserRouter>
      </LanguageProvider>
    </Provider>
  );
}

export default App;
